import { defineStore } from 'pinia';
export const useKbbWithVinStore = defineStore('kbbwithvinstore', {
  state() {
    return {
      kellyBlueBookMoreVehiclesWithVin: '',
      kellyBlueBookWithVin: '',
    };
  },
});
